import FormElement from "./formElement";
import FormSection from "../formSections/formSection";
import {FormSectionValidationMode} from "~/enums/formSectionValidationMode"

export default class PageBreak extends FormElement {
  static placeholder(index) {
    return `Page ${index + 1}`;
  }

  initializeAfterParentSet(): this {
    this.formSection.buildPage();
    return this;
  }

  afterMove(oldParent: FormSection, newParent: FormSection): void {
    if (oldParent === newParent) {
      return;
    }

    oldParent.destroyPage();
    newParent.buildPage();
  }

  destroy(nameIndex?: number): void {
    this.formSection.destroyPage(nameIndex);
    super.destroy();
  }

  get index(): number {
    return this.parent.pageBreaks.indexOf(this);
  }

  get endOf(): string {
    return this.parent.pages[this.index] || PageBreak.placeholder(this.index);
  }

  get startOf(): string {
    return this.parent.pages[this.index + 1] || PageBreak.placeholder(this.index + 1);
  }

  get validationMode(): FormSectionValidationMode {
    return this.parent.validation_mode
  }

  set validationMode(value: FormSectionValidationMode) {
    this.parent.validation_mode = value
  }
}